<template>
	<svg :width="width" :height="height" :viewBox="viewBox" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M18 10C18 10.848 17.936 11.696 17.792 12.512C17.36 15.216 15.216 17.36 12.512 17.792C11.696 17.936 10.848 18 10 18C9.152 18 8.304 17.936 7.488 17.792C4.784 17.36 2.64 15.216 2.208 12.512C2.064 11.696 2 10.848 2 10C2 9.152 2.064 8.304 2.208 7.488C2.64 4.784 4.784 2.64 7.488 2.208C8.304 2.064 9.152 2 10 2C10.848 2 11.696 2.064 12.512 2.208C15.216 2.64 17.36 4.784 17.792 7.488C17.936 8.304 18 9.152 18 10Z" fill="url(#paint0_linear_324_717)"/>
		<path d="M14.752 14.992H6.688C6.16 14.992 5.648 14.704 5.408 14.24C5.12 13.696 5.232 13.04 5.664 12.608L11.28 6.992H7.248C6.144 6.992 5.248 6.096 5.248 4.992H12.672C13.2 4.992 13.712 5.28 13.952 5.744C14.24 6.288 14.128 6.944 13.696 7.376L8.096 13.008H12.752C13.856 13.008 14.752 13.888 14.752 14.992Z" fill="white"/>
		<defs>
			<linearGradient id="paint0_linear_324_717" x1="5.78656" y1="17.2979" x2="14.2134" y2="2.70211" gradientUnits="userSpaceOnUse">
				<stop offset="5.79195e-07" stop-color="#0845BF"/>
				<stop offset="0.1911" stop-color="#0950DE"/>
				<stop offset="0.3823" stop-color="#0B59F6"/>
				<stop offset="0.5" stop-color="#0B5CFF"/>
				<stop offset="0.6732" stop-color="#0E5EFE"/>
				<stop offset="0.7774" stop-color="#1665FC"/>
				<stop offset="0.8633" stop-color="#246FF9"/>
				<stop offset="0.9388" stop-color="#387FF4"/>
				<stop offset="1" stop-color="#4F90EE"/>
			</linearGradient>
		</defs>
	</svg>
</template>

<script>

export default {
	name: "ZoomIcon",
	props: {
		width: {
			type: Number,
			default: 20,
		},
		height: {
			type: Number,
			default: 20,
		},
	},
	computed: {
		viewBox() {
			const { width, height, } = this;
			return `0 0 ${ width } ${ height }`;
		},
	},
};
</script>

<style lang="scss" scoped></style>
